import type { Popup } from '../popup';
import { TriggerStateBroadcaster } from './trigger-state-broadcaster';

/** Opens as soon as popup setup and targeting checks finish, without a timer. */
export class PageLoadTrigger {
	private broadcaster: TriggerStateBroadcaster;

	constructor(private popup: Popup) {
		this.broadcaster = new TriggerStateBroadcaster(
			popup.getFeedId(),
			'page_load'
		);
	}

	public init(): void {
		this.broadcaster.setState('triggered');
		this.popup.show();
	}

	public destroy(): void {
		this.broadcaster.destroy();
	}
}
